<template>
    <div class="main">
        <div class="container">
            <!-- 左侧布局 -->
            <div class="left" @mouseleave="hideItem">
                <div class="menuList" v-for="(item, index) in leftMenu" :key="index" @mouseover="showItem( index )" :class="hoverActive == index + 1 ? 'zIndex bgImg' : '' ">
                    <div class="iconbox">
                        <span class="iconfont" :class="item.iconClass"></span>
                    </div>
                    <div class="name">
                        {{ item.name }}
                    </div>
                </div>
                <!-- 鼠标hover显示的内容 -->
                <div class="hover_content" v-if="hoverActive == 1 && show">
                    <img src="../../assets/static/index/left_nav_bg2.png" class="conBgImg" alt="">
                    <div class="dept_list_box" >
                        <div class="dept_title">
                            智慧工会云平台
                        </div>
                        <div class="dept_box">
                            <div class="dept_item" v-for="(item ,index) in DeptList" :key="index" @click="getDeptInfo( item.deptId )">
                                {{ item.deptName }}
                            </div>
                        </div>
                    </div>
                    <div class="dept_info_box" v-if="DeptInfo && DeptInfo.deptId">
                        <div class=" dept_title"> <span class="iconfont payment-icon-gonghui"></span> {{ DeptInfo.deptName }}</div>
                        <div class="dept_name">类型:{{ DeptInfo.deptType }}</div>
                        <div class="dept_name">党支部书记:{{ DeptInfo.leaders }}</div>
                        <div class="dept_name">联系电话:{{ DeptInfo.phone }}</div>
                        <div class="dept_name">联系地址:{{ DeptInfo.address }}</div>
                    </div>

                    <!-- <div class="btn_boxs" v-if="DeptInfo.deptId">
                        <el-button @click="showZhiBu(DeptInfo.deptId)">查看支部详情</el-button>
                    </div> -->
                </div>

                <div class="hover_content" v-if="hoverActive == 2 && show">
                    <img src="../../assets/static/index/left_nav_bg2.png" class="conBgImg" alt="">
                    <div class="menu_item" v-for="(item, index ) in NavbarList" :key="index">
                        <div class="bg_box">
                            {{ item.title }}
                        </div>
                        <div class="nav_box">
                            <div class="nav_item" v-for="(nav, inx) in item.navList" :key="inx" @click="showDetail( nav, inx )">
                               <span>●</span> {{ nav.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="hover_content" v-if="hoverActive == 3 && show">
                    <img src="../../assets/static/index/left_nav_bg2.png" class="conBgImg" alt="">
                    <div class="left_class_list_box">
                        <div class="left_class_title">
                            红色学堂
                        </div>
                        <div class="left_class_box">
                            <div class="left_class_item" v-for="(item, index) in redSchoolTypes" @click="showRedSchool( item, index )" :key="item.type">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                    <div class="right_kaoshi_box">
                        <div class="right_kaoshi_title">
                            在线考试
                        </div>
                        <div class="kaoshi_status">
                            <div class="status_item" v-for="(item,index) in kaoshiMenu" :key="index" @click="showKaoshi( item, index )">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 中间布局 -->
            <div class="middle">
                <el-carousel :interval="5000" arrow="always" height="415px" indicator-position="none">
                    <el-carousel-item v-for="(item, index)  in SwiperList" :key="index">
                        <div class="news_box" @click="showNewsDetail( item )">
                            <img :src="item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') != -1"  alt="">
                            <img :src="$ImgUrl + item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') == -1"  alt="">
                            <div class="news_title">
                                {{ item.news_title }}
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>

            <!-- 右侧布局 -->
            <div class="right">
                <div class="title">
                    <div class="name">
                        <span class="iconfont icon-fuwudating1"></span>
                        <span class="name">服务导航</span>
                    </div>
                    <!-- <div class="more">
                        更多 >>
                    </div> -->
                </div>

                <div class="menubox">
                    <div class="menu hvr-push" v-for="( item, index) in rightMenu" :key="index"  @click="changePath( item )">
                        <div class="iconbox" :style="item.style">
                            <span :class="item.iconClass"></span>
                        </div>
                        <div class="name">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                leftMenu:[
                    { iconClass: "icon-zuzhimoxing", name: "组织建设" },
                    // { iconClass: "icon-fuwudating", name: "服务大厅" },
                    { iconClass: "icon-wangluodangxiao", name: "服务之窗" },
                ], // 左侧

                rightMenu: [
                    { iconClass: "iconfont icon-guanwang", name: "最新公告", style:"background: linear-gradient(-20deg, rgb(100 169 224), #2767c4 );", path: "/moreNewsList?cate_id=242&isSearch=0&keyword=" },
                    // { iconClass: "iconfont icon-qiandao", name: "每日签到", style:"background: linear-gradient(-20deg, #FF8D8D, #FC4343);" },
                    { iconClass: "iconfont icon-ditu1", name: "工会时讯", style:"background: linear-gradient(-20deg, #FFD38D, #FC9F43);" ,path: "/notify/172/1/1/工作动态"},
                    { iconClass: "iconfont icon-zg-rdsq", name: "我要入会", style:"background: linear-gradient(-20deg, #FF8D8D, #EB3A47);", event: 'join' },
                    { iconClass: "iconfont icon-zhutidangri", name: "办事指南", style:"background: linear-gradient(-20deg, #FFD38D, #FC9F43);", path: "/notify/223/187/1/办事指南" },
                    { iconClass: "iconfont icon-sanhuiyike", name: "下载专区", style:"background: linear-gradient(-20deg, #FFAD8D, #FC6643);", path: "/notify/224/187/2/下载专区" },
                    { iconClass: "iconfont icon-icon02", name: "轮播图", style:"background: linear-gradient(-20deg, #FFAD8D, #FC6643);" , path:"/NewsDetail/8663?cate_id=2"},
                    { iconClass: "iconfont icon-dangjianxinwen", name: "基层动态", style:"background: linear-gradient(-20deg, #FF8D8D, #EB3A47);" , path:"/notify/179/1/2/基层动态" },
                    { iconClass: "iconfont icon-zhiduhuaguanli", name: "教工活动", style:"background: linear-gradient(-20deg, #FFD38D, #FC9F43);", path:"/notify/216/186/0/文体活动" },
                    { iconClass: "iconfont icon-qiandao", name: "工会信箱", style:"background: linear-gradient(-20deg, #FFD38D, #FC9F43);", path:"/" },
                ], // 右侧布局
                hoverActive: "",
                show: false,
                NewsList: [], // 新闻列表

                NavbarList:[
                    {
                        title: "",
                        navList:[
                            { name: "福利保障", path: "/notify/222/187/0/福利保障"},
                            { name: "办事指南", path: "/notify/223/187/1/办事指南"},
                            { name: "下载专区", path: "/notify/224/187/2/下载专区"},
                            // { name: "反腐倡廉", cate_id: "187"},{ name: "领导讲话", cate_id: "178"},{ name: "党章党规", cate_id: "7"},
                        ]
                    },
                    // {
                    //     title: "党群宣传",
                    //     navList:[
                    //         { name: "政治建设", cate_id: "168"},{ name: "思想建设", cate_id: "172"},
                    //         { name: "组织建设", cate_id: "179"},{ name: "作风建设", cate_id: "171"},{ name: "制度建设", cate_id: "157"},
                    //     ]
                    // },
                    // {
                    //     title: "组织生活",
                    //     navList:[
                    //         { name: "主题党日", path: "/MeetingShow/meeting/0?meetingType=1&buildingPartyType=1&title=主题党日&activeMain=1&activeChild=0" },
                    //         { name: "谈心谈话", path: "/MeetingShow/meeting/0?meetingType=5&buildingPartyType=2title%3D谈心谈话&activeMain=1&activeChild=4" },
                    //         { name: "投票活动", path: "/MeetingShow/toupiao?activeMain=1&activeChild=5"},
                    //         { name: "民主评议", path: "/MeetingShow/mzpy?activeMain=1&activeChild=6" },
                    //         { name: "志愿活动", path: "/MeetingShow/zhiyuan?activeMain=1&activeChild=7" },
                    //     ]
                    // },
                ],
                redSchoolTypes: [],
                DeptList: [],
                deptId: "",
                DeptInfo: {},
                kaoshiMenu: [
                    { name: "全部", type: "0" },{ name: "未开始", type: "1" },{ name: "进行中", type: "2" },{ name: "已结束", type: "3" },
                ],
                formData: {},
                JoinShow: false,
                dialogVisible: false,
                dialogImageUrl: "",
            }
        },
        props: {
            SwiperList: Array
        },
        mounted() {
            this.getDeptList()
            this.getRedSchoolTypes()
        },
        methods: {
            // 去新闻分类页
            showDetail ( item, index ) {
                if ( item.cate_id ) {
                    this.$router.push({
                        path: "/notify",
                        query: {
                            id: item.cate_id,
                            keyword: "",
                            isSearch: 0
                        }
                    })
                } else if ( item.path ) {
                    this.$router.push( item.path )
                }
            },
            // 鼠标进入事件
            showItem( index ) {
                this.hoverActive = index + 1
                this.show = true 
            },
            // 鼠标离开事件
            hideItem ( index ) {
                this.hoverActive = ""
                this.show = true 
            },
            // 展示新闻详情
            showNewsDetail ( item ) {
                console.log( item )
                this.$router.push({
                    path: `/NewsDetail/${item.news_id}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            },

            // 去考试
            showKaoshi ( item, index ) {
                this.$router.push({
                    path:"/RedSchool",
                    query: {
                        TabCur: 1,
                        MenuIndex: index,
                        TypeIndex: 1
                    }
                })
            },

            // 去红色学堂
            showRedSchool ( item, index ) {
                this.$router.push({
                    path:"/RedSchool",
                    query: {
                        TabCur: 0,
                        MenuIndex: index,
                        TypeIndex: 1
                    }
                })
            },
            // 获取红色学堂type
            async getRedSchoolTypes () {
                this.redSchoolTypes = []
                let res = await this.$axios.post("/lencon/pc/index/school_type")
                if ( res.data.code == 1 ) {
                    this.redSchoolTypes = res.data.data
                }
            },

            // 获取组织信息
            async getDeptList () {
                let res = await this.$axios.post("/lencon/pc/maps/dept_list")
                if ( res.data.code == 1 ) {
                    this.DeptList = res.data.data
                }
            },

            // 获取单个组织信息
            async getDeptInfo ( deptId) {
                let {  token } = this 
                let res = await this.$axios.post("/lencon/pc/maps/dept_info", { deptId, token })
                if ( res.data.code == 1 ) {
                    this.DeptInfo = res.data.data
                }
            },

            // 条状
            changePath ( item ) {
                if ( item && item.path && !item.event && !item.link ) {
                    this.$router.push( item.path )
                } else if ( item && !item.path && item.event == 'join'  && !item.link) {
                        this.$emit("showJoin", true)
                } else {
                    window.open(item.link)
                }
            },

            // 查看支部详情
            showZhiBu (deptId) {
                if ( deptId ) {
                    this.$router.push(`/ZuzhiInfo/${deptId}`)
                }
            }  
        }
    }
</script>


<style lang="scss" scoped>
.main {
    width: 100%;
    .container {
        width: 1200px;
        margin: 0 auto;
        padding-top: 30px;
        display: flex;
        justify-content: space-between;
        .left {
            position: relative;
            left: 0;
            top: 0;
            .zIndex {
                    z-index:21;
            }
            .bgImg {
                background: url("../../assets/static/index/left_nav_bg.png") 0 0 no-repeat;
                background-size: 100% 100%;
            }
            .menuList {
                width: 200px;
                height: 188px;
                background-color: #ffffff;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                font-size: 18px;
                position: relative;
                left: 0;
                top: 0;
                cursor: pointer;
                .iconbox {
                    span {
                        font-size: 30px;
                        color: #2767c4 ;
                        
                    }
                }
                .name {
                    line-height: 30px;
                }
            }

            .hover_content {
                position: absolute;
                left: 199px;
                top: 0;
                width: 1000px;
                height: 415px;
                border-left: 1px solid #aaa;
                background-color: #fff;
                z-index:20;
                background: linear-gradient(0deg, #FFFFFF, #FFEBEB);
                display: flex;
                padding-left: 30px;
                padding-top: 30px;
                // justify-content: space-around;
                .btn_boxs {
                    position: absolute;
                    right: 30px;
                    bottom: 30px;
                    .el-button {
                        background-color: #2767c4 ;
                        color:#fff;
                    }
                }
                .conBgImg {
                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: -1;
                }
                .dept_list_box {
                    width: 500px;
                    overflow-y: scroll;
                    .dept_title {
                        font-size: 24px;
                        font-weight: bold;
                        line-height: 40px;
                        color: #2767c4 ;
                        padding-left: 10px;
                    }
                    .dept_box {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        .dept_item {
                            margin: 10px;
                            cursor: pointer;
                            font-size: 17px;
                        }
                    }
                }
                .dept_info_box {
                    // padding-top: 20px;
                    margin-left: 100px;
                    .dept_title {
                        font-size: 24px;
                        color: #2767c4 ;
                        font-weight: bold;
                        .iconfont {
                            font-size: 30px;
                        }
                    }
                    .dept_name {
                        line-height: 40px;
                    }
                }
                .menu_item {
                    width: 100%;
                    // display: flex;
                    margin: 10px;
                    .bg_box {
                        width: 300px;
                        height: 156px;
                        line-height: 156px;
                        color: #fff;
                        text-align: center;
                        font-size: 24px;
                        background: url("../../assets/static/index/left_nav_bg3.png") 0 0 no-repeat;
                        background-size: 100% 100%;
                    }
                    .nav_box {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        .nav_item {
                            margin: 10px;
                            cursor: pointer;
                        }
                        span {
                            color: #D6D4D4;
                        }
                    }
                }

                .left_class_list_box {
                    width: 500px;
                    padding-top: 40px;
                    .left_class_title {
                        color: #2767c4 ;
                        font-weight: bold;
                        font-size: 24px;
                        text-align: center;
                    }
                    .left_class_box {
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        .left_class_item {
                            width: 140px;
                            text-align: center;
                            line-height: 40px;
                            border: 1px solid #F9BAB6;
                            margin: 10px;
                            cursor: pointer;
                            &:hover {
                                background-color: #2767c4 ;
                                color: #fff;
                            }
                        }
                    }
                }

                .right_kaoshi_box {
                    flex: 1;
                    padding-top: 40px;
                    .right_kaoshi_title {
                        color: #2767c4 ;
                        font-weight: bold;
                        font-size: 24px;
                        text-align: center;
                    }
                    .kaoshi_status {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .status_item {
                            width: 190px;
                            height: 52px;
                            background: #2767c4 ;
                            color: #fff;
                            text-align: center;
                            line-height: 52px;
                            margin: 10px 0;
                            cursor: pointer;
                            
                        }
                    }
                }

            }
        }

        .middle {
            width: 650px;
            height: 415px;
            // margin: 0 20px;
            .news_box {
                width: 100%;
                height: 100%;
                position: relative;
                left: 0;
                top: 0;
                img {
                    width: 650px;
                    height: 415px;
                }
                .news_title {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    height: 60px;
                    width: 100%;
                    padding-left: 20px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    line-height: 60px;
                    background-color: rgba(0,0,0,.45);
                    font-size: 18px;
                    color: #fff;
                }
            }
        }

        .right {
            width: 300px;
            height: 415px;
            background-color: #fff;
            .title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #2767c4 ;
                padding: 10px;
                background: #F7EDED;
                .name {
                    font-size: 22px;
                    .iconfont {
                        font-size: 20px;
                        margin-right: 10px;
                    }
                }
                .more {
                    font-size: 14px;
                    color: #B3B3B3;
                }
            }
            .menubox {
                width: 100%;
                // height: 360px;
                display: flex;
                flex-wrap: wrap;
                // justify-content: flex-start;
                background-color: #fff;
                padding: 20px 0;
                .menu {
                    width: 100px;
                    height: 80px;
                    text-align: center;
                    margin-top: 20px;
                    cursor: pointer;
                    .iconbox {
                        width: 50px;
                        height: 50px;
                        margin: 0 auto;
                        border-radius: 50%;
                        text-align: center;
                        line-height: 50px;
                        span {
                            font-size: 25px;
                            color: #FFFFFF;
                        }
                    }
                    .name {
                        font-size: 16px;
                        line-height: 30px;
                    }
                }
            }
        }
    }
    
}
</style>